import { render, staticRenderFns } from "./MeasurementPoint.vue?vue&type=template&id=4dfeaf25"
import script from "./MeasurementPoint.vue?vue&type=script&lang=js"
export * from "./MeasurementPoint.vue?vue&type=script&lang=js"
import style0 from "./MeasurementPoint.vue?vue&type=style&index=0&id=4dfeaf25&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports